import { useGetReschedulesByMentor } from '@actions';
import { Spin } from 'antd';
import { RESCHEDULE_REASON_LABELS } from '../../../utils/constants';
import { ColumnHeader, EmptyState, formatLeadTime, SectionHeading, TableShell } from './common';

const ReschedulesTab = (props: { month: string }) => {
  const { data: reschedules, isLoading } = useGetReschedulesByMentor({ month: props.month });

  if (isLoading) {
    return (
      <div className="flex justify-center py-24">
        <Spin size="large" />
      </div>
    );
  }

  const totalReschedules = (reschedules ?? []).reduce((sum, mentor) => sum + mentor.count, 0);

  return (
    <section className="flex flex-col gap-4">
      <SectionHeading
        title="Reschedules by mentor"
        description="Meetings rescheduled during the selected month, with how far ahead of the meeting the change was made."
      />
      {reschedules && reschedules.length > 0 ? (
        <TableShell minWidth="min-w-[720px]">
          <thead>
            <tr className="border-b border-white/10 text-xs uppercase tracking-wide text-customGrey">
              <th className="px-5 py-3 text-left font-semibold">Mentor</th>
              <ColumnHeader dot="lila">Reschedules</ColumnHeader>
              <ColumnHeader>Avg lead time</ColumnHeader>
              <th className="px-5 py-3 text-left font-semibold">Reasons</th>
            </tr>
          </thead>
          <tbody>
            {reschedules.map((mentor) => (
              <tr
                key={mentor.mentorId}
                className="border-b border-white/5 align-top transition-colors last:border-b-0 hover:bg-surfaceHover"
              >
                <td className="px-5 py-3 text-left text-customLight">{mentor.mentorName}</td>
                <td className="px-5 py-3 text-right tabular-nums">{mentor.count}</td>
                <td className="px-5 py-3 text-right tabular-nums">
                  {formatLeadTime(mentor.averageRescheduleLeadTimeMinutes)}
                </td>
                <td className="px-5 py-3 text-left">
                  {mentor.reasons?.length ? (
                    <div className="flex flex-wrap gap-2">
                      {mentor.reasons.map((reasonItem) => (
                        <span
                          key={reasonItem.reason}
                          className="rounded-full bg-surfaceHover px-2.5 py-1 text-xs text-customLight"
                        >
                          {RESCHEDULE_REASON_LABELS[reasonItem.reason] ?? reasonItem.reason} ·{' '}
                          {reasonItem.count}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="text-xs text-customGrey">No reason recorded</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t border-white/10 font-semibold text-white">
              <td className="px-5 py-3 text-left">Total</td>
              <td className="px-5 py-3 text-right tabular-nums">{totalReschedules}</td>
              <td className="px-5 py-3" />
              <td className="px-5 py-3" />
            </tr>
          </tfoot>
        </TableShell>
      ) : (
        <EmptyState>No reschedules for this month.</EmptyState>
      )}
    </section>
  );
};

export default ReschedulesTab;
